export const HELPDESK_ROOT = '/helpdesk';

/** Agent routes that lived at the app root before M3; they now redirect to `/helpdesk/…`. */
export const LEGACY_HELPDESK_AGENT_PATHS = [
  'tickets',
  'warteschlangen',
  'changes',
  'wissen',
  'sla',
  'freigaben',
  'automatisierung',
  'integrationen',
  'assets',
  'auswertung',
  'status',
  'einstellungen/kategorien',
  'einstellungen/system',
] as const;

export function isHelpdeskAgentPath(pathname: string): boolean {
  return pathname === HELPDESK_ROOT || pathname.startsWith(`${HELPDESK_ROOT}/`);
}

/** `/helpdesk/tickets/5` → `/tickets/5`; `/helpdesk` → `/`; other paths unchanged. */
export function stripHelpdeskPrefix(pathname: string): string {
  if (!isHelpdeskAgentPath(pathname)) {
    return pathname;
  }
  return pathname.slice(HELPDESK_ROOT.length) || '/';
}

/** Legacy root path (e.g. `/tickets/5`) → `/helpdesk/tickets/5`; `/` → Intranet start. */
export function legacyAgentPathToHelpdesk(pathname: string): string {
  return pathname === '/' || pathname === '' ? '/intranet' : `${HELPDESK_ROOT}${pathname}`;
}
